import { takeLatest } from 'redux-saga'
import { fork, put } from 'redux-saga/effects'
import { MARK_LEGACY_PROJECT_HIDDEN } from 'actions/projectActionTypes'
import updateCalculatorProject from 'helpers/updateCalculatorProject'
import { removeLegacyProjectAction } from 'actions/projectActions'

export function* markLegacyProjectHidden(action) {
  if (ENV !== 'development') yield fork(updateCalculatorProject, action.uniqueKey, { display_in_v3: false })
  yield put(removeLegacyProjectAction(action.uniqueKey))
}

export function* watchMarkLegacyProjectHidden() {
  yield* takeLatest(MARK_LEGACY_PROJECT_HIDDEN, markLegacyProjectHidden)
}



// WEBPACK FOOTER //
// ./src/sagas/markLegacyProjectHiddenSaga.js